import { datadogRum } from '@datadog/browser-rum';
import { isRumActive, logger } from './state';

/** Tags every later event with the whitelabel's friendly name; does nothing for `null`. */
export function setRumWhitelabel(friendlyName: string | null): void {
  if (!isRumActive() || !friendlyName) {
    return;
  }

  try {
    datadogRum.setGlobalContextProperty('whitelabel', friendlyName);
  } catch (err) {
    logger.warn('Failed to set RUM whitelabel', { friendlyName }, err);
  }
}

/** Marks the current view as handed to the other portal, `target`. */
export function markRumHandoff(target: 'v2' | 'v3'): void {
  if (!isRumActive()) {
    return;
  }

  try {
    datadogRum.setViewContextProperty('handoff', target);
  } catch (err) {
    logger.warn('Failed to mark RUM handoff', { target }, err);
  }
}

/** Marks the current view as one that stayed on the previous view's page. */
export function markRumInPage(): void {
  if (!isRumActive()) {
    return;
  }

  try {
    datadogRum.setViewContextProperty('inPage', true);
  } catch (err) {
    logger.warn('Failed to mark RUM in-page view', err);
  }
}
